import { request } from "./request";

const BASE_URL = "/api/tasks";

export default {
  async all() {
    return await request(`${BASE_URL}`);
  },

  async fetch(taskId) {
    return await request(`${BASE_URL}/${taskId}`);
  },

  async markAsDone(taskId) {
    return await request({
      method: "PUT",
      url: `${BASE_URL}/${taskId}`,
      data: { done: true },
    });
  },

  async nextModule(taskId, moduleNr) {
    return await request({
      method: "PUT",
      url: `${BASE_URL}/${taskId}`,
      data: { current_module: moduleNr },
    });
  },

  async restartTask(taskId) {
    return await request({
      method: "PUT",
      url: `${BASE_URL}/${taskId}/restart`,
    });
  },

  async startTask(taskId) {
    return await request({
      method: "PUT",
      url: `${BASE_URL}/${taskId}`,
      data: { started: true },
    });
  },

  async selectResult(taskId, result) {
    return await request({
      method: "PUT",
      url: `${BASE_URL}/${taskId}`,
      data: { done: true, result },
    });
  },
};
